import { faker } from '@faker-js/faker'

import { constructFullAddress } from './utils'

type JsonPrimitive = string | number | boolean | null
export type JsonValue =
  | JsonPrimitive
  | JsonValue[]
  | { [key: string]: JsonValue }

export type Customer = {
  external_id?: string | null
  individual_name?: string | null
  company_name?: string | null
  email?: string | null
  mobile_phone?: string | null
  office_phone?: string | null
  address_string?: string | null
  memo?: string | null
  metadata?: JsonValue | null
  reference_number?: string | null
  tags: { key: string; value: string }[]
}

export const generateCustomer = (
  overrides: Partial<Customer> = {},
): Customer => {
  const firstName = faker.person.firstName()
  const lastName = faker.person.lastName()
  const fullName = `${firstName} ${lastName}`

  const base: Customer = {
    external_id: faker.string.uuid(),
    individual_name: fullName,
    company_name: faker.company.name(),
    email: faker.internet.email({ firstName, lastName }),
    mobile_phone: faker.phone.number(),
    office_phone: faker.phone.number(),
    address_string: constructFullAddress(),
    memo: faker.lorem.paragraph(),
    reference_number: `CUST-${faker.string.alphanumeric({ length: 5, casing: 'upper' })}`,
    tags: [],
  }

  return {
    ...base,
    ...overrides,
  }
}

export const getCustomers = (count: number, demoName: string): Customer[] => {
  return Array.from({ length: count }, (_, idx) =>
    generateCustomer({ external_id: `${demoName}-customer-${idx}` }),
  )
}
